'use client'
import { getCurrencySymbol, useOpenDeposit } from '@l2p/apps-shared'
import { useRouter } from 'next/navigation'
import React, { useCallback, useMemo } from 'react'
import { FixedButton } from '../../Buttons'
import styles from './styles.module.scss'
// import { InputCheckbox } from '@l2p/ui-components'
import { useBalance } from '@l2p/swr-hooks'
import { useTranslations } from 'next-intl'

interface BalanceCardProps {
  currency?: string | null
  withDrawable?: string | null
}
const BalanceCard: React.FC<BalanceCardProps> = ({
  currency,
  withDrawable,
}) => {
  const t = useTranslations('translation')
  const openDeposit = useOpenDeposit()
  const router = useRouter()
  const { data: balanceData } = useBalance()

  // const { setActiveCurrency } = useSetActiveCurrency({
  //   successAction: router.refresh,
  // })

  const isActive = useMemo(() => {
    return currency === balanceData?.currency
  }, [currency, balanceData])

  const onChangeHandler = useCallback(() => {
    // if (!isActive && currency) {
    //   setActiveCurrency({ currency })
    // }
  }, [])

  if (!balanceData) return null

  return (
    <div className={`${styles.container} ${isActive ? styles.active : ''}`}>
      {/*<InputCheckbox*/}
      {/*  label={isActive ? t('default') : t('makeDefault')}*/}
      {/*  id={currency || ''}*/}
      {/*  onClick={onChangeHandler}*/}
      {/*  withBorder={true}*/}
      {/*  isActive={isActive}*/}
      {/*  checked={isActive}*/}
      {/*/>*/}
      <div className={styles.currency}>{currency}</div>
      {balanceData && currency && (
        <div className={styles.amount}>
          <div>{`${getCurrencySymbol(currency)}`}</div>
          <div>{Number(balanceData?.totalAmount).toFixed(2)}</div>
        </div>
      )}

      <div className={styles.properties}>
        <div>
          <div className={styles.property}>{t('withdrawable')}</div>
          <div className={styles.value}>{withDrawable}</div>
        </div>
        {balanceData && (
          <div>
            <div className={styles.property}>{t('lockedByBonus')}</div>
            <div className={styles.value}>
              {Number(
                (Number(balanceData?.totalAmount) || 0) -
                  (Number(balanceData?.amount) || 0),
              ).toFixed(2)}
            </div>
          </div>
        )}
      </div>
      <FixedButton
        onClick={openDeposit}
        color="gradient"
        width="100%"
        maxWidth="100%"
      >
        {t('deposit')}
      </FixedButton>
    </div>
  )
}

export default BalanceCard
